// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions-container--EnU0z{display:flex;margin:0;flex-wrap:wrap}", "",{"version":3,"sources":["webpack://./src/pages/ImportingTool/FileDetails/ActionsPanel/actions.module.scss"],"names":[],"mappings":"AAAA,0BACE,YAAA,CACA,QAAA,CACA,cAAA","sourcesContent":[".actions-container {\n  display: flex;\n  margin: 0;\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions-container": "actions-container--EnU0z"
};
export default ___CSS_LOADER_EXPORT___;
